import Flickity from '../../node_modules/flickity';
import 'flickity-fade';

document.addEventListener('alpine:init', () => {
    Alpine.data('PartnerInterviews', () => ({
        carousel: null,
        index: 0,
        init() {
            this.initCarousel();
        },
        initCarousel() {
            if (!this.$refs.carousel) return;

            this.carousel = new Flickity(this.$refs.carousel, {
                on: {
                    ready: function() {
                        window.dispatchEvent(new Event('resize'));
                    },
                },
            });
        },
    }));
});
